<template>
  <div class="login-page">
    <TopBarUnLogin />
    <OauthPage />
    <FooterBarWhite />
  </div>
</template>

<script>
import TopBarUnLogin from '@/components/TopBarUnLogin.vue'
import OauthPage from '@/components/OauthPage.vue'
import FooterBarWhite from '@/components/FooterBar/FooterBarWhite.vue'

export default {
  name: 'Login',
  components: {
    TopBarUnLogin,
    OauthPage,
    FooterBarWhite
  }
}
</script>